import React from 'react';
import classNames from 'classnames';
import { formatTimestampAsDateWithTime } from '../../../utils/dates-utils';
import { SupportIcon, UserIcon } from './TicketDetails';
import { ExpandMore } from '@material-ui/icons';
import PropTypes from 'prop-types';

export const TicketHeader = ({ ticket, classes, handleOpenTickets, isOpened }) => {
  const { id, created_at, subject, tags } = ticket;
  const supportTags = ['testtag', 'Support via Dinkassa.se'];
  const isSupport = supportTags.some(tag => tags.includes(tag));
  const isOpen = isOpened(id);
  
  const renderIcon = () => {
    if (!isOpen) {
      return null;
    }
    return isSupport ? <SupportIcon classes={classes} /> : <UserIcon classes={classes} />;
  };
  
  return (
    <div onClick={() => handleOpenTickets(ticket.id)}
         className={classNames(classes.headerWrapper, {
           [classes.headerWrapperSupport]: isSupport,
           [classes.headerWrapperExpanded]: isOpen,
         })}>
      {renderIcon()}
      <span className={classNames(classes.headerIcon, { [classes.headerIconExpanded]: isOpen })}>
        <ExpandMore />
      </span>
      <p className={classes.headerItem}>{subject}</p>
      <p className={classes.headerDate}>{formatTimestampAsDateWithTime(created_at)}</p>
    </div>
  );
};

TicketHeader.propTypes = {
  ticket: PropTypes.object,
  classes: PropTypes.object,
  handleOpenTickets: PropTypes.func,
  isOpened: PropTypes.func,
};